module.exports = __webpack_public_path__ + "c20644d2d4dcf94f828cab71e8074419.svg";